// import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import axios from 'axios';

// import { useLayoutEffect } from 'react';
import HeaderWithSearch from '../components/HeaderWithSearch'
import Footer from '../components/Footer.jsx';

import '../Assets/css/searchresult.css'
import '../Assets/css/rangeslider.css'
import '../Assets/css/datepicker.css'


import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/budgetrange.js'
import  '../Assets/js/searchresult.js'

function Search()
{
    // const [metaData, setMetaData] = useState({
    //     meta_title: "PinginGo - Search Result",
    //     meta_description: "More Ping More Discount. Cari penginapan hidden gem dan beauty of nature hanya di PinginGo.",
    //     meta_keywords: "Glamping Indonesia, Staycation, Penginapan Alam, Hidden Gem, PinginGo",
    //     meta_photo: "/Assets/images/Ref-PinginGo.jpg"
    // });

    useEffect(() =>
    {
        window.CallDefaultFunction("SearchResult");

        // let CurrentUrl = new URL(window.location.href);
        // const path = window.location.pathname;
        // const locationsearch = path.split("/").pop().split(".")[0];

        // let URLSearchHotel = window.AddURL + "/hotels/province/" + locationsearch + "/city-region";

        // window.CallApiAxios({
        //     method: "GET",
        //     url: URLSearchHotel,
        // })
        // .then(res =>
        // {
        //     //console.log(res);

        //     if(res.data.data.length > 0)
        //     {
        //         let SearchData = res.data.data[0];
        //         let LocationName = SearchData.province;
        //         if(CurrentUrl.searchParams.has('area'))
        //             LocationName = LocationName + ", " + CurrentUrl.searchParams.get("area");

        //         setMetaData({
        //             meta_title: "Cari Penginapan Hidden Gem Terbaik di " + LocationName + " - PinginGo",
        //             meta_description: "Temukan pilihan akomodasi berbasis alam terbaik di " + LocationName + ". Booking glamping, villa, dan penginapan alam unik dengan harga terbaik hanya di PinginGo.",
        //             meta_keywords: "Penginapan di "  + LocationName +  ", glamping "  + LocationName +  ", villa "  + LocationName +  ", penginapan alam "  + LocationName +  ", hidden gem "  + LocationName +  ", staycation "  + LocationName +  ", hotel unik "  + LocationName +  ", tempat nginep di "  + LocationName +  ", booking hotel "  + LocationName +  ", penginapan murah " . $locationame,
        //             meta_photo: "/Assets/images/Ref-PinginGo.jpg"
        //         });
        //     }
        // })
        // .catch(err =>
        // {
        //     //console.error(err);
        // });

    }, []);
    
    // Append Body Element To 'root' -----------------------------------------------------
    return (
        <>
            {/* <Helmet>
                <title>{metaData.meta_title}</title>

                <meta name="description" content={metaData.meta_description} />
                <meta name="keywords" content={metaData.meta_keywords} />

                <meta property="og:title" content={metaData.meta_title} />
                <meta property="og:description" content={metaData.meta_description} />
                <meta property="og:image" content={metaData.meta_photo} />
                <meta name="author" content="PinginGo"/>
                <meta property="og:type" content="PinginGo Dynamic Pages"/>
            </Helmet> */}

            <div className="basic">

                <HeaderWithSearch />

                <div className="MainContentSection" id="MainContentSectionToInsantiate">
                    <div className="MainSectionWithBlueHeader">
                        <div className="FilterBlocker" style={{ display: "none" }} id="FilterBlocker"></div>

                        <div className="FilterleftPanel" id="FilterleftPanel">
                            <div style={{ width: "100%", height: "fit-content", display: "flex" }}>
                                <p className="LabelGreyHeaderText InterBoldTextFont" id="FiltersHeaderText">Filters</p>
                                <img src="/Assets/images/ButtonIcon/cancel-x-grey.svg" className="CloseButtonInsidePanel Selectable2" onClick={() => window.ShowFilterMenuLeftClicked()} />
                            </div>

                            <div className="BasicHeaderAndInputWrapper">
                                <p className="LabelGreyHeaderSmallerText InterBoldTextFont" id="BudgetPerNightHeaderText">Budget per Night</p>
                                <div className="SliderContainer">
                                    <div className="slider-track BasicRoundRadius" id="slider-track"></div>
                                    <input type="range" min="0" max="1000000" defaultValue="0" id="slider-1" className="budgetslidermin"/>
                                    <input type="range" min="0" max="1000000" defaultValue="1000000" id="slider-2" className="budgetslidermax"/>
                                </div>

                                <div className="BudgetInputFieldContainer">
                                    <div className="InputFieldSeparator">
                                        <p className="InputFieldHeaderText InterMediumTextFont" id="MinHeaderText">Min</p>
                                        <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{ width: "100%", minWidth: "100%" }}>
                                            <input type="text" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" id="InputFieldMin" placeholder="Rp 150.000" data-current-budget-input="0" />
                                        </div>
                                    </div>
                                    <div className="InputFieldSeparator" style={{ marginLeft: "auto" }}>
                                        <p className="InputFieldHeaderText InterMediumTextFont" id="MaxHeaderText">Max</p>
                                        <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{ width: "100%", minWidth: "100%" }}>
                                            <input type="text" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" id="InputFieldMax" placeholder="Rp 300.000" data-current-budget-input="1000000" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="BasicHeaderAndInputWrapper" id="PopularFilterMainContainer">
                                <p className="LabelGreyHeaderSmallerText InterBoldTextFont" id="FilterLeftHeadersPopularFilter">Popular Filter in Bali</p>
                                <div className="FilterContainerWrapper" id="LeftPopularFilterContainer">
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                </div>
                            </div>

                            <div className="BasicHeaderAndInputWrapper" id="AreaFilterMainContainer">
                                <p className="LabelGreyHeaderSmallerText InterBoldTextFont">Area</p>
                                <div className="FilterContainerWrapper" id="LeftAreaFilterContainer">
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                </div>
                            </div>

                            <div className="BasicHeaderAndInputWrapper" id="CategoryFilterMainContainer">
                                <p className="LabelGreyHeaderSmallerText InterBoldTextFont" id="CategoryHeaderText">Category</p>
                                <div className="FilterContainerWrapper" id="LeftCategoryFilterContainer">
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                    <div className="PopularFilterPanel">
                                        <label className="FilterCheckBoxContainer" style={{pointerEvents: 'none'}}>
                                            <input type="checkbox" className="FilterCheckBox Selectable" value="Free Breakfast" />
                                            <span className="CheckBoxSpan"></span>
                                        </label>
                                        <p className="CheckBoxText InterMediumTextFont loading_grey" style={{color:'transparent'}}>Now Loading</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="FilterRightSection">
                            <div className="FilterSortByTopContainer BasicRoundRadius">
                                <p className="LabelGreyHeaderText InterBoldTextFont" style={{ margin: "auto 0" }} id="SortByHeaderText">Sort by:</p>
                                <div className="SortTopButtonContainer">
                                    <button className="SortTopButton SortTopButtonSelected Selectable2" id="BestMatchSortButton" onClick={() => window.SortButtonClicked('BestMatch')}>
                                        <p className='HideOnMobile3' id="BestMatchSortText">Best Match</p>
                                        <p className='ShowOnMobile3' id="BestMatchSortAbvText">Best</p>
                                    </button>
                                    <button className="SortTopButton Selectable2" id="LowestPriceSortButton" onClick={() => window.SortButtonClicked('LowestPrice')}>
                                        <p className='HideOnMobile3' id="LowestPriceSortText">Lowest Price</p>
                                        <p className='ShowOnMobile3' id="LowestPriceSortAbvText">Min Price</p>
                                    </button>
                                    <button className="SortTopButton Selectable2" id="HotDealsSortButton" onClick={() => window.SortButtonClicked('HotDeals')}>
                                        <p className='HideOnMobile3' id="HotDealsSortText">Hot Deals</p>
                                        <p className='ShowOnMobile3' id="HotDealsSortAbvText">Deals</p>
                                    </button>
                                    <button className="SortTopButton Selectable2" id="AlmostFullSortButton" onClick={() => window.SortButtonClicked('AlmostFull')}>
                                        <p className='HideOnMobile3' id="AlmostFullSortText">Almost Full</p>
                                        <p className='ShowOnMobile3' id="AlmostFullSortAbvText">Ltd Qty</p>
                                    </button>
                                    <div className="SelectedSortOrangeWrapper" id="SelectedSortOrangeWrapper">
                                        <div className="SelectedSortOrange BasicRoundRadius"></div>
                                    </div>
                                </div>
                            </div>

                            <div className="NoFeaturedPropertyFoundContainer" id="NoFeaturedPropertyFoundContainer" style={{ display: "none" }}>
                                <img src="/Assets/images/ButtonIcon/no-featured.svg" className="NoFoundIcon" />
                                <p className="NoFoundHeaderText InterBoldTextFont" id="NoHotelAvailableText">No Hotel Available</p>
                                <p className="NoFoundMessageText InterRegularTextFont" id="NoHotelAvailableMessageText">Please change your Filter, Date or Location to find a new one</p>
                            </div>

                            <div className="SearchResultPanelContainer" id="SearchResultPanelContainer">
                                <div className="RoomHotelPanel">
                                    <div className="RoomHotelWrapper">
                                        <div className="RoomHotelImageInsidePanel">
                                            <div className="loading_grey ImageFullCover"></div>
                                        </div>
                                        <div className="RoomHotelImageRightSectionInSeparatorsidePanel">
                                            <div className="RoomHotelPanelInfoLeftWrapper">
                                                <div className="RoomHotelNameInsidePanel loading_grey"></div>
                                                <div className="RoomSmallInfo loading_grey"></div>
                                                <div className="RoomHotelDescriptionInsidePanel loading_grey"></div>
                                                <div className="RoomHotelDisplayedNameInsidePanel loading_grey">
                                                    <p className="InterBoldTextFont" style={{ opacity: 0 }}>--</p>
                                                </div>
                                            </div>
                                            <div className="RoomHotelPanelInfoRightWrapper">
                                                <div className="RoomBottomInfoLeft">
                                                    <div className="RoomHotelRightInfo3 loading_grey"></div>
                                                    <div className="RoomHotelRightInfo2 loading_grey"></div>
                                                    <div className="RoomHotelRightInfo2 loading_grey"></div>
                                                </div>
                                                <div className="RoomBottomInfoRight">
                                                    <div className="RoomHotelRightInfo1 loading_grey" style={{ marginLeft: "auto" }}></div>
                                                    <div className="RoomHotelRightInfo2 loading_grey" style={{ marginLeft: "auto" }}></div>
                                                    <div className="RoomHotelRightInfo3 loading_grey" style={{ marginLeft: "auto" }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="scrollSentinel"></div>
                        </div>
                    </div>
                </div>

                <button className="FilterSearchButton Selectable2" onClick={()=> window.ShowFilterMenuLeftClicked()}>
                    <img src="/Assets/images/ButtonIcon/filter-white.svg"/>
                </button>
            </div>

            <Footer/>
        </>

    )
}

export default Search